/* eslint class-methods-use-this: 0 */
import { MeRepository } from 'common/repositories/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import Recaptcha from 'services/recaptcha';

const _serviceDependencies = ['$rootScope', '$scope', 'Util', 'UserRestService', 'Auth'];

let _Util;
let _UserRestService;
let _user;
let _$scope;
let _$rootScope;
let _confirmCode;
let _Auth;

/**
 * @ngdoc service
 * @name controllers.ChangeEmailModal
 *
 * @description
 * Crop Image controller
 */
class ChangeEmailModal {

    /**
     * @param  {any} $rootScope
     * @param  {any} $scope
     * @param  {any} Util
     * @param  {any} UserRestService
     */
    constructor(
        $rootScope, $scope, Util,
        UserRestService, Auth,
    ) {

        _Util = Util;
        _UserRestService = UserRestService;
        _user = MeRepository.getMyUser();
        _$scope = $scope;
        _$rootScope = $rootScope;
        _$scope.Recaptcha = Recaptcha;
        _Auth = Auth;

        _$scope.submitted = false;
        _$scope.loading = false;
        _$scope.expiredCode = false;
        _$scope.requestsExceeded = false;

        // $scope assigned functions
        _$scope.onSubmit = this.onSubmit;
        _$scope.closeModal = this.closeModal;
        _$scope.resendEmail = this.resendEmail;
        _$scope.setCaptchaResponse = this.setCaptchaResponse;
        _confirmCode = this.confirmCode;

        // if there is no email value, close modal
        if (!$rootScope.changeEmail) {

            this.closeModal();

        }

        // delete changeEmail object when $scope is destroyed
        _$scope.$on('$destroy', () => {

            delete $rootScope.changeEmail;
            delete $rootScope.passwordConfirmationFor;

        });

    }

    confirmCode() {

        const headers = {};

        const captchaRespose = _$scope.Recaptcha.getCaptchaResponse();

        if (captchaRespose) {

            headers['X-Avira-Captcha-Token'] = captchaRespose;

        }

        const payload = {
            data: {
                id: _user.id,
                attributes: {
                    email: _$rootScope.changeEmail.newEmail,
                },
                relationships: {
                    provider: {
                        data: {
                            type: _user.relationships.partner.data.type,
                            id: _user.relationships.partner.data.id,
                        },
                    },
                },
                type: _user.type,
            },
            meta: {
                change_email_code: this.confirmCodeForm.code.$viewValue,
                password: _$rootScope.changeEmail.kp,
            },
        };

        /* if captcha is required and there is no captcha response available,
               trigger alert and stop login process */
        if (_$scope.captchaRequired && !_$scope.captchaRespose) {

            _Util.triggerAnimation('#error-message-captcha', 'animated shake');
            return;

        }

        _$scope.submitted = true;
        _$scope.loading = true;

        this.confirmCodeForm.code.$setValidity('serverValidation', true);

        const formIsValid = this.confirmCodeForm.$valid;

        if (formIsValid) {

            // send the payload with the PUT update user method
            _UserRestService.update(_user.id, payload, headers).then(() => {

                Mixpanel.send('ConnectWeb Change Email Success');

                this.closeModal();

                _$scope.loading = false;
                _$scope.expiredCode = false;
                _$scope.requestsExceeded = false;
                _Auth.logOut();

            }).then(null, (error) => {

                const errorCode =
                    (error.data.errors && error.data.errors[0]) ? error.data.errors[0].code : false;

                _$scope.loading = false;

                switch (errorCode) {

                // invalid email code
                case '21117':

                    this.confirmCodeForm.code.$setValidity('serverValidation', false);

                    break;

                    // expired code case
                case '21119':

                    _$scope.expiredCode = true;

                    break;

                case '21120':

                    _$scope.requestsExceeded = true;

                    break;

                // captcha is required
                case '918':

                    _$scope.Recaptcha.execute();
                    break;

                case '21127':
                    this.confirmCodeForm.code.$setValidity('serverValidation', false);
                    break;

                default:

                    Alert.error('cw.account.details.messages.error');

                }

                _Util.triggerAnimation('.error', 'animated shake');

            });

        } else {

            _$scope.loading = false;
            _Util.triggerAnimation('.error', 'animated shake');

        }

    }


    resendEmail() {

        const payload = {
            data: {
                id: _user.id,
                attributes: {
                    email: _$rootScope.changeEmail.newEmail,
                },
                relationships: {
                    provider: {
                        data: {
                            type: _user.relationships.partner.data.type,
                            id: _user.relationships.partner.data.id,
                        },
                    },
                },
                type: _user.type,
            },
            meta: {
                language: CWCONFIG.language,
                password: _$rootScope.changeEmail.kp,
            },
        };

        _UserRestService.update(_user.id, payload).then(() => {

        }).then(null, (error) => {

            const errorCode =
                (error.data.errors && error.data.errors[0]) ? error.data.errors[0].code : false;

            switch (errorCode) {

            case '21118':

                Alert.success('cw.deploy.got.mail.title');

                break;

            default:

                Alert.error('cw.notification.sendEmail.error');

            }

        });

    }
    onSubmit() {

        if (_$scope.Recaptcha.isCaptchaRequired()) {

            _$scope.Recaptcha.execute();

        } else {

            const _confirmCodeBind = _confirmCode.bind(this);
            _confirmCodeBind();

        }

    }

    closeModal() {

        _Util.closeModal();

    }

    setCaptchaResponse(response) {

        _$scope.Recaptcha.setCaptchaResponse(response);
        const _confirmCodeBind = _confirmCode.bind(this);
        _confirmCodeBind();

    }

}

_serviceDependencies.push(ChangeEmailModal);

angular.module('controllers')
    .controller('ChangeEmailModal', _serviceDependencies);




// WEBPACK FOOTER //
// ./scripts/controllers/modals/my-account/change-email/change-email-modal.js